<template>
  <div v-if="myCurrency">
    <div class="estimated-currency">
      <span>Approx: {{myCurrency}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'EstimatedCurrency',
    data () {
      return {};
    },
    props: {
      myCurrency: ''
    }
  };
</script>

<style>
  .estimated-currency {
    border-radius: 2px;
    border: 1px solid #36454f;
    color: #36454f;
    background-color: rgba(21, 27, 31, 0.2);
    display: inline-block;
    padding: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/EstimatedCurrency.vue